/*!
 * Copyright (c) REWE Digital GmbH
 */
export const defaultArrowPath = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';
export const defaultMainOptions = {
    labelNextSlideButton: 'Nächstes Bild',
    labelPrevSlideButton: 'Vorheriges Bild',
    imageFit: 'cover',
    arrowPath: defaultArrowPath,
    pagination: false,
    arrows: false,
    keyboard: 'global',
    gap: 10,
    breakpoints: {
        600: {
            pagination: true,
        },
    },
};
export const defaultThumbnailOptions = {
    arrowPath: defaultArrowPath,
    imageFit: 'cover',
    pagination: false,
    width: '100%',
    height: 600,
    direction: 'ttb',
    useScroll: true,
    gap: 10,
    wheel: true,
};
//# sourceMappingURL=defaults.js.map
